import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class MechanicService {
  static async getAssignedRequests(mechanicId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/mechanic_get_assigned_requests`, {
        method: 'POST',
        body: JSON.stringify({ p_mechanic_id: mechanicId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching assigned requests:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async updateRequestStatus(requestId, status) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/mechanic_update_request_status`, {
        method: 'POST',
        body: JSON.stringify({ p_request_id: requestId, p_status: status }),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error updating request status:', error);
      return { success: false, error: error.message };
    }
  }

  static async getPerformanceStats(mechanicId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/mechanic_get_performance`, {
        method: 'POST',
        body: JSON.stringify({ p_mechanic_id: mechanicId }),
      });
      return { success: true, data: (Array.isArray(data) ? data[0] : data) || {}, error: null };
    } catch (error) {
      console.error('Error fetching performance stats:', error);
      return { success: false, data: {}, error: error.message };
    }
  }

  static async updateProfile(mechanicId, profileData) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/mechanic_update_profile`, {
        method: 'POST',
        body: JSON.stringify({
          p_mechanic_id: mechanicId,
          p_name: profileData.name,
          p_phone: profileData.phone,
          p_address: profileData.address,
        }),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error updating profile:', error);
      return { success: false, error: error.message };
    }
  }
}

